import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });
let refreshing = null;
const AT = "sc_at";
const RT = "sc_rt";

export function saveTokens(data) {
  if (data?.access_token) localStorage.setItem(AT, data.access_token);
  if (data?.refresh_token) localStorage.setItem(RT, data.refresh_token);
}
export function clearTokens() {
  localStorage.removeItem(AT);
  localStorage.removeItem(RT);
}

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(AT);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh", { refresh_token: localStorage.getItem(RT) || "" })
        .then((r) => saveTokens(r.data))
        .finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        clearTokens();
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.message) return d.errors ? `${d.message}: ${d.errors.join(" ")}` : d.message;
  return String(d);
}

export async function downloadFile(path, filename, params) {
  const r = await api.get(path, { responseType: "blob", params });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export default api;
